import { useState } from 'react';
import Button from '../ui/Button';

function formatFechaCorta(fechaaplicacion) {
  if (!fechaaplicacion) return '—';
  try {
    return new Date(`${fechaaplicacion}T00:00:00`).toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return fechaaplicacion;
  }
}

// UI dice "Eliminar", pero funcionalmente esto siempre anula (estado=
// ANULADA) — nunca hace DELETE físico. Ver anular_aplicacion_campo.
function AnularAplicacionModal({ open, aplicacion, onConfirm, onCancel, confirming = false, error = '' }) {
  const [motivo, setMotivo] = useState('');

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center"
      role="dialog"
      aria-modal="true"
      onClick={confirming ? undefined : onCancel}
    >
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-lg" onClick={(event) => event.stopPropagation()}>
        <h3 className="text-lg font-semibold text-gray-900">Eliminar aplicación</h3>
        <p className="mt-2 text-sm text-gray-600">¿Deseas eliminar esta aplicación?</p>

        <div className="mt-3 rounded-xl bg-gray-50 px-3 py-2 text-sm text-gray-700">
          <p className="font-medium">{aplicacion?.huerto || '—'}</p>
          <p>{aplicacion?.cuartel || '—'}</p>
          <p className="text-gray-500">{formatFechaCorta(aplicacion?.fechaaplicacion)}</p>
        </div>

        <p className="mt-3 text-sm text-gray-500">
          Esta acción quitará la aplicación de tus registros activos, pero mantendrá su historial.
        </p>

        <div className="mt-4">
          <label htmlFor="motivo_anulacion" className="mb-1 block text-sm font-medium text-gray-700">
            Motivo (opcional)
          </label>
          <input
            id="motivo_anulacion"
            type="text"
            value={motivo}
            onChange={(event) => setMotivo(event.target.value)}
            placeholder="Ej: Registrada por error"
            className="min-h-[48px] w-full rounded-xl border border-gray-300 px-4 text-base text-gray-900 placeholder-gray-400 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
          />
        </div>

        {error && <p className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}

        <div className="mt-6 flex flex-col gap-3">
          <Button variant="primary" onClick={() => onConfirm(motivo)} disabled={confirming} className="bg-red-600 hover:bg-red-700 active:bg-red-800">
            {confirming ? 'Eliminando...' : 'Eliminar aplicación'}
          </Button>
          <Button variant="secondary" onClick={onCancel} disabled={confirming}>
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AnularAplicacionModal;
